export const userRoutes = [
  {
    path: '/user/wbmgr',
    name: '坐席管理',
    icon: 'iconmeneicon-yonghu',
    children: [],
    component: () => import('@/views/auth/wbmgr')
  }, {
    path: '/user/rolemgr',
    name: '角色权限管理',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/auth/rolemgr')
  }, {
    path: '/user/sgmgr',
    name: '技能组管理',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/auth/sgmgr')
  }
]

export const channelRoutes = [
  {
    path: '/channel/web',
    name: 'Web接入',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/web')
  }, {
    path: '/channel/h5',
    name: 'H5接入',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/h5')
  },
  {
    path: '/channel/weixin',
    name: '微信',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/weixin')
  },
  {
    path: '/channel/weixinapp',
    name: '微信小程序',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/weixinapp')
  },
  {
    path: '/channel/app',
    name: 'APP接入',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/app')
  }, {
    path: '/channel/weibo',
    name: '微博接入',
    icon: 'iconmenuicon-xitong',
    children: [],
    component: () => import('@/views/channel/weibo')
  }
]

export const systemRoutes = [
  {
    path: '/system/strategyApply',
    name: '路由策略应用',
    component: () => import('@/views/system/strategyApply'),
    children: []
  },
  {
    path: '/system/strategy',
    name: '路由策略管理',
    component: () => import('@/views/system/strategy'),
    children: []
  },
  { path: '/system/custom_field', name: '自定义字段', component: () => import('@/views/system/components/CustomField') },
  { path: '/system/operation_log', name: '操作记录', component: () => import('@/views/system/components/OperationLog') },
  { path: '/system/blacklist', name: '访客黑名单', component: () => import('@/views/system/blacklist') }
]
